export function parseBoolean(value?: unknown): 'Yes'|'No' {
  return !!value ? 'Yes' : 'No';
}

export function asPercentageValue(value: number, maximumFractionDigits: number = 2): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits,
  });

  return `${formatter.format(value)}%`;
}

export function asCurrencyFormat(value: number): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(value);
}

export const parseFileReadableFilesize = (size: any) => {
  const baseInt: number = 1024;
  const sizeUnit: number = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));

  return (size / Math.pow(baseInt, sizeUnit) as any).toFixed(0) * 1 + ['B', 'KB', 'MB', 'GB', 'TB'][sizeUnit];
};

export function capitalizeFirstLetter(val: string): string {
  return String(val).charAt(0).toUpperCase() + String(val).toLowerCase().slice(1);
}